import ReactGA from "react-ga4";

const GoogleAnalyticsActions = {};

// Call once, when the app first loads.
GoogleAnalyticsActions.initGoogleAnalytics = (key) => {
  ReactGA.initialize(key);
};

// Call on every route change, including the initial one, so SPA
// navigation (which never causes a real page load) is actually tracked.
GoogleAnalyticsActions.trackPageview = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

export { GoogleAnalyticsActions };
